import {types} from './types';

const initialState = {
    list: [],
    history: {
        data: [],
        countPage: 1
    },
    events: {
        data: [],
        countPage: 1
    }
}

export function mobileAdminReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST:
            return { ...state, list: action.payload};
        case types.SET_HISTORY: 
            return { ...state, history: action.payload};
        case types.SET_EVENT:
            return { ...state, events: action.payload};
        default:
            return state
    }
}